import type { LucideIcon } from 'lucide-react';
import React from 'react';

interface BillActionButtonProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  isBusy?: boolean;
  isActive?: boolean;
  title?: string;
}

/** Labeled icon button for the bill modal's header toolbar. */
export const BillActionButton: React.FC<BillActionButtonProps> = ({
  icon: Icon,
  label,
  onClick,
  disabled = false,
  isBusy = false,
  isActive = false,
  title,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled || isBusy}
    title={title}
    aria-pressed={isActive || undefined}
    aria-busy={isBusy || undefined}
    className={`inline-flex h-9 items-center gap-1.5 rounded-lg border px-3 text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-pos-primary focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-white disabled:text-slate-400 ${
      isActive
        ? 'border-pos-primary bg-green-50 text-pos-primary'
        : 'border-slate-300 bg-white text-slate-700 hover:border-pos-primary hover:text-pos-primary'
    }`}
  >
    {isBusy ? (
      <span
        aria-hidden="true"
        className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent motion-reduce:animate-none"
      />
    ) : (
      <Icon size={16} aria-hidden="true" />
    )}
    {label}
  </button>
);
